import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To212(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectRatio1To212"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M0 2.5A1.5 1.5 0 0 1 1.5 1h1A1.5 1.5 0 0 1 4 2.5v7A1.5 1.5 0 0 1 2.5 11h-1A1.5 1.5 0 0 1 0 9.5zm6.01 0a.5.5 0 0 1 .5-.5h4.972a.5.5 0 0 1 0 1H6.51a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h4.972a.5.5 0 0 1 0 1H6.51a.5.5 0 0 1-.5-.5m.5-2.5a.5.5 0 0 0 0 1h2.486a.5.5 0 0 0 0-1zm-.5 4.5a.5.5 0 0 1 .5-.5h2.486a.5.5 0 0 1 0 1H6.509a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To212);
